type HasTypename = { __typename?: string };

/**
 * Generic type guard for GraphQL generated types.
 * Narrows a union to a specific member by comparing `__typename`.
 *
 * @example
 * const owner: OwnerUnion = ...;
 * if (isGqlType(owner, "DealerCustomer")) {
 *   // owner is narrowed to DealerCustomer
 * }
 */
export function isGqlType<
  TUnion extends HasTypename,
  TName extends NonNullable<TUnion["__typename"]>,
>(
  obj: TUnion,
  typename: TName
): obj is Extract<TUnion, { __typename?: TName }> {
  return obj.__typename === typename;
}
